import styled from 'styled-components';

interface TitleProps {
  color: string;
}

export const Status = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Title = styled.h1<TitleProps>`
  color: ${(props) => props.theme.colors.text};
  width: fit-content;
  padding: 5px 10px;
  background-color: ${(props) => props.color};
  border-radius: 4px;
  margin-bottom: 15px;
  cursor: pointer;
`;

export const Table = styled.table`
  border-bottom: 0.5px solid rgba(128, 128, 128, 0.4);
  border-collapse: collapse;
  color: ${(props) => props.theme.colors.text};
  border-radius: 4px;
`;

export const TableHeader = styled.thead`
  background-color: ${(props) => props.theme.colors.table.header};

  td {
    font-weight: bold;
  }
`;

export const TableColumn = styled.td`
  padding: 5px;
  border: 1px solid rgba(128, 128, 128, 0.4);
`;
